var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_654_10096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.08333 5.52051H1.25L5 1.77051L8.75 5.52051H7.91667",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.0835 5.52051V8.43717C2.0835 8.65819 2.17129 8.87015 2.32757 9.02643C2.48385 9.18271 2.69582 9.27051 2.91683 9.27051H7.0835C7.30451 9.27051 7.51647 9.18271 7.67275 9.02643C7.82903 8.87015 7.91683 8.65819 7.91683 8.43717V5.52051",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9.27059V6.77059C3.75 6.54958 3.8378 6.33761 3.99408 6.18133C4.15036 6.02505 4.36232 5.93726 4.58333 5.93726H5.41667C5.63768 5.93726 5.84964 6.02505 6.00592 6.18133C6.1622 6.33761 6.25 6.54958 6.25 6.77059V9.27059",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_10096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.520508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.84ee2fb7755edc4a494c6e769f5fcee3.svg";
export { ForwardRef as ReactComponent };